/* eslint-disable import/prefer-default-export */
import pick from 'lodash/pick';

export const pickDefaultValues = <T, U>(defaultValues: T, obj: U): T => {
  const keys = Object.keys(defaultValues);
  return pick(obj, keys) as T;
};
